var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-file-input',{attrs:{"dense":"","multiple":"","chips":"","outlined":"","accept":"image/*,.pdf","prepend-inner-icon":"mdi-plus","prepend-icon":""},on:{"change":_vm.onSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }